/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function CouponIcon({ fill }) {
	return (
		<svg
			width="20"
			height="13"
			viewBox="0 0 20 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.119 4.39102V5.4003C12.9834 5.62942 13.724 6.00894 13.724 6.99646C13.724 8.11358 12.8599 8.64286 12.119 8.68606V9.00126C12.119 9.13726 12.0831 9.21598 11.9339 9.21598C11.7707 9.21598 11.7485 9.13726 11.7485 9.00126V8.68606C11.2545 8.65726 10.1377 8.52894 10.1377 7.85598C10.1377 7.55518 10.3523 7.26174 10.6431 7.26174C10.7462 7.26174 10.8691 7.31475 11.0128 7.37678C11.2154 7.46423 11.4595 7.56958 11.7485 7.56958V6.4595C10.5139 6.1091 10.1647 5.66494 10.1647 5.00638C10.1647 4.04702 10.884 3.4387 11.7485 3.35998V3.0307C11.7485 2.8947 11.7847 2.81598 11.9339 2.81598C12.0977 2.81598 12.119 2.8947 12.119 3.0307V3.35998C12.6129 3.37406 13.3844 3.51742 13.3844 4.11902C13.3844 4.39102 13.2079 4.65566 12.9161 4.65566C12.7961 4.65566 12.6967 4.60038 12.5887 4.54034C12.4604 4.46903 12.3201 4.39102 12.119 4.39102ZM11.7485 5.2787C11.5018 5.22846 11.3583 5.09246 11.3583 4.86334C11.3583 4.60574 11.5018 4.44094 11.7485 4.39102V5.2787ZM12.119 7.56958V6.57438C12.366 6.6531 12.5313 6.78174 12.5313 7.08286C12.5313 7.32606 12.366 7.56958 12.119 7.56958Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 3.36C20 3.7312 19.7016 4.032 19.3337 4.032C18.2289 4.032 17.3333 4.9344 17.3333 6.048C17.3333 7.16128 18.2289 8.064 19.3337 8.064C19.7016 8.064 20 8.3648 20 8.736V11.424C20 11.7949 19.7016 12.096 19.3337 12.096H0.666667C0.29873 12.096 0 11.7949 0 11.424V8.736C0 8.3648 0.29873 8.064 0.666667 8.064C1.77111 8.064 2.66698 7.16128 2.66698 6.048C2.66698 4.9344 1.77111 4.032 0.666667 4.032C0.29873 4.032 0 3.7312 0 3.36V0.672C0 0.3008 0.29873 0 0.666667 0H19.3337C19.7016 0 20 0.3008 20 0.672V3.36ZM18.6667 10.752V9.3408C17.3549 9.07232 16.3298 8.03904 16.0635 6.71648C15.6971 4.89792 16.8625 3.12448 18.6667 2.7552V1.344H7.33334V2.688H6.00032V1.344H1.33333V2.7552C2.64508 3.02368 3.67048 4.05696 3.93683 5.37952C4.30318 7.19776 3.13746 8.97152 1.33333 9.3408V10.752H6.00032V9.408H7.33334V10.752H18.6667Z"
				fill={fill}
			/>
			<path
				d="M6 6.71998H7.33302V5.37598H6V6.71998Z"
				fill={fill}
			/>
			<path
				d="M6 8.73597H7.33302V7.39197H6V8.73597Z"
				fill={fill}
			/>
			<path
				d="M6 4.70395H7.33302V3.35995H6V4.70395Z"
				fill={fill}
			/>
		</svg>
	);
}

CouponIcon.propTypes = {
	fill: PropTypes.string,
};

CouponIcon.defaultProps = {
	fill: 'currentColor',
};
